import(/* webpackMode: "eager" */ "/var/www/node/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lato\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"]}],\"variableName\":\"lato\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/var/www/node/frontend/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/node/frontend/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/var/www/node/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node/frontend/src/app/persistantProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node/frontend/src/components/ChatBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node/frontend/src/components/Header.tsx");
